export const checkEmail = ({ endpointUrl, email }) => {
    return fetch(`${endpointUrl}/customers/check-email-exist/?email=${encodeURIComponent(email)}`);
};
